/* eslint-disable */
import axios from 'axios'
import router from '@/router/router'
import {
	MessageBox
} from 'element-ui'
import store from '@/store'
import NProgress from 'nprogress'
import storage from '@/utils/localstorage.js'

// 前端自定义错误信息
// const codeMessage = {
//   200: '服务器成功返回请求的数据。',
//   201: '新建或修改数据成功。',
//   202: '一个请求已经进入后台排队（异步任务）。',
//   204: '删除数据成功。',
//   400: '发出的请求有错误，服务器没有进行新建或修改数据的操作。',
//   401: '用户没有权限（令牌、用户名、密码错误）。',
//   403: '用户得到授权，但是访问是被禁止的。',
//   404: '发出的请求针对的是不存在的记录，服务器没有进行操作。',
//   406: '请求的格式不可得。',
//   410: '请求的资源被永久删除，且不会再得到的。',
//   422: '当创建一个对象时，发生一个验证错误。',
//   500: '服务器发生错误，请检查服务器。',
//   502: '网关错误。',
//   503: '服务不可用，服务器暂时过载或维护。',
//   504: '网关超时。',
// }
const CancelToken = axios.CancelToken
const source = CancelToken.source();
const baseURL = process.env.VUE_APP_AXIOS_BASE_URL;
// create an axios instance实例
const service = axios.create({
	baseURL: baseURL, // api 的 base_url
	timeout: 1000 * 30 // request timeout
})
// request interceptor 请求拦截器
service.interceptors.request.use(

	config => {
		const {
			title,
			domain,
			ename,
			type
		} = store.state.domainInfo
		var jwt = storage.get('jwt')
		if (typeof storage.get('jwt') != "object") {
			jwt = storage.get('jwt').replace(/\"/g, "")
		}
		// 给所有请求添加自定义header
		config.headers['Accept'] = 'application/json,text/html;q=0.9,image/webp,*/*;q=0.8'
		config.headers['Content-Type'] = 'application/json;charset=UTF-8'
		config.headers['Authorization'] = 'Bearer ' + jwt
		config.headers['XL-DOMAIN-ENAME'] = ename
		config.headers['XL-DOMAIN-TYPE'] = type
		NProgress.start("config", config)
		return config;
	},
	error => {
		// Do something with request error
		return Promise.reject(error);
	}
)

// response interceptor 响应拦截器
service.interceptors.response.use(
	/**
	 * 下面的注释为通过在response里，自定义code来标示请求状态
	 * 当code返回如下情况则说明权限有问题，登出并返回到登录页
	 * 如想通过 xmlhttprequest 来状态码标识 逻辑可写在下面error中
	 * 以下代码均为样例，请结合自生需求加以修改，若不需要，则可删除
	 */
	response => {
		NProgress.done()
		const res = response.data || {}
		console.log(response,":error.response")
		if (response.status === 200 && res.code == 200) {
			if (res.hasOwnProperty('data')) {
				return res.data
			}
			return res
		} else {
			if (res.code === 1001 || res.code === 1002|| res.code === 1004 || res.code ===
				2001 || res.code === 2005 || res.code === 2002) {
				localStorage.removeItem('user_info')
				localStorage.removeItem('XL_SESSION_ID')
				router.push('/login')
			} else {
				let errMsg = `${res.code}: ${res.message}`;
				MessageBox.alert(errMsg, 'ERROR', {
					confirmButtonText: '确定',
					type: 'error',
					callback: () => {
						// if (error.response.status === 500) {
						//   router.push({path:'/login'})
						// }
					}
				})
				
			}
			// 改变全局loading状态，解决业务错误引起按钮不可用
			store.commit('changeLoadingStatus', false)
			return Promise.reject(res)
		}
	},
	error => {
		NProgress.done()
		// 移除本地用户数据,开发时请注释
		// localStorage.removeItem('user_info')
		// localStorage.removeItem('XL_SESSION_ID')
		// 判断标志，防止触发多次弹窗
		const {
			code,
			message
		} = error.response.data
		let errMsg = code ? `${code}: ${message}` : `${error.response.status}: ${error.response.statusText}`
		errMsg = errMsg + ((error.response.status === 500) ? '，Please login again' : '')
		if (error.response.status === 400 && error.response.data.code === 2002) {
			// MessageBox.alert("登录态失效",'ERROR',{
			//   confirmButtonText: '确定',
			//   type: 'error',
			//   callback: () => {
			//     localStorage.removeItem('user_info')
			//     localStorage.removeItem('XL_SESSION_ID')
			//     router.push('/login')
			//   }
			// })
			localStorage.removeItem('user_info')
			localStorage.removeItem('XL_SESSION_ID')
			router.push('/login')
		} else if (error.response.status === 404) {
			return Promise.reject(error.response);
		} else {
			MessageBox.alert(errMsg, 'ERROR', {
				confirmButtonText: '确定',
				type: 'error',
				callback: () => {
					// if (error.response.status === 500) {
					//   router.push({path:'/login'})
					// }
				}
			})
		}
		return Promise.reject(error.response)
	}
)
/**
 * 封装get请求
 * @param {*} url 请求路径
 * @param {*} params 参数
 * @returns {Promise}
 */
export function get(url, params, headers = {}) {
	return new Promise((resolve, reject) => {
		var getObj = {}
		if (params == null) {
			getObj = {
				method: 'get',
				url,
				headers: headers,
				cancelToken: source.token
			}
		} else {
			getObj = {
				method: 'get',
				url,
				params: params,
				headers: headers,
				cancelToken: source.token
			}
		}

		service(getObj).then(response => {
			resolve(response);
		}).catch(err => {
			if (typeof(err.code) === 'undefined') {
				reject(err)
			}
		})
	})
}

/**
 * 封装post请求
 * @param {*} url 请求路径
 * @param {*} params 参数
 * @returns {Promise}
 */
export function post(url, params, headers = {}) {
	return new Promise((resolve, reject) => {
		service({
			method: 'post',
			url,
			data: params,
			headers: headers,
			cancelToken: source.token
		}).then(response => {
			resolve(response);
		}).catch(err => {
			console.log("post->catch", err)
			if (typeof(err.code) === 'undefined') {
				reject(err)
			}
		})
	})
}

/**
 * 封装put请求
 * @param {*} url 请求路径
 * @param {*} params 参数
 * @returns {Promise}
 */
export function put(url, params, headers = {}) {
	return new Promise((resolve, reject) => {
		service({
			method: 'put',
			url,
			data: params,
			headers: headers,
			cancelToken: source.token
		}).then(response => {
			resolve(response);
		}).catch(err => {
			console.log("put->catch", err)
			if (typeof(err.code) === 'undefined') {
				reject(err)
			}
		})
	})
}

/**
 * 封装delete请求
 * @param {*} url 请求路径
 * @param {*} params 参数
 * @returns {Promise}
 */
export function Delete(url, params, headers = {}) {
	return new Promise((resolve, reject) => {
		service({
			method: 'delete',
			url,
			data: params,
			headers: headers,
			cancelToken: source.token
		}).then(response => {
			resolve(response);
		}).catch(err => {
			console.log("delete->catch", err)
			if (typeof(err.code) === 'undefined') {
				reject(err)
			}
		})
	})
}


/**
 * 封装head请求
 * @param {*} url 请求路径
 * @param {*} params 参数
 * @returns {Promise}
 */
export function head(url, params, headers = {}) {
	return new Promise((resolve, reject) => {
		service({
			method: 'head',
			url,
			data: params,
			headers: headers,
			cancelToken: source.token
		}).then(response => {
			console.log("resolve", response)
			resolve(response);
		}).catch(err => {
			console.log("resolve", err)
			if (typeof(err.code) === 'undefined') {
				reject(err)
			}
		})
	})
}

// export default service
